import {Base64} from 'js-base64';

export function parsePayload(jwt) {
  const payload = jwt.split('.')[1];
  const payloadJson = Base64.decode(payload);
  return JSON.parse(payloadJson);
}
